/* LUXURIA – Hero "Showroom" Slider
   Crossfade mit langsamem Zoom, Autoplay mit Pause, Swipe, Tastatur,
   Nachladen der Folgebilder nach dem Seitenaufbau, reduzierte Bewegung, mobile CTA-Leiste. */
(function () {
  'use strict';

  var FADE_MS = 1400;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadSlideImages(slide) {
    if (!slide || slide.__luxLoaded) return;
    slide.__luxLoaded = true;
    slide.querySelectorAll('[data-lux-srcset]').forEach(function (el) {
      el.setAttribute('srcset', el.getAttribute('data-lux-srcset'));
      el.removeAttribute('data-lux-srcset');
    });
    slide.querySelectorAll('img[data-lux-src]').forEach(function (img) {
      img.setAttribute('src', img.getAttribute('data-lux-src'));
      img.removeAttribute('data-lux-src');
    });
  }

  function Slider(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-go]'));
    this.captions = Array.prototype.slice.call(root.querySelectorAll('[data-caption]'));
    this.toggleBtn = root.querySelector('[data-toggle]');
    this.index = 0;
    this.interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion && this.slides.length > 1;
    this.userPaused = false;
    this.hoverPaused = false;
    this.inView = true;
    this.timer = null;
    this.remaining = this.interval;
    this.startedAt = 0;

    root.classList.add('is-ready');
    if (reduceMotion) root.classList.add('is-reduced');
    this.slides.forEach(function (s, i) { s.style.setProperty('--lux-hs-z', i === 0 ? 2 : 0); });
    this.slides[0] && (this.slides[0].__luxLoaded = true);

    this.bind();
    this.preload();
    this.observe();
    this.updateToggle();
    this.play();
  }

  Slider.prototype.preload = function () {
    var self = this;
    // Folgebilder erst nach dem Laden der Seite (LCP-Bild hat Vorrang)
    var run = function () {
      var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 300); };
      idle(function () { loadSlideImages(self.slides[1]); });
      setTimeout(function () { self.slides.forEach(loadSlideImages); }, 2500);
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  };

  Slider.prototype.go = function (next, user) {
    var count = this.slides.length;
    if (count < 2) return;
    next = (next + count) % count;
    if (next === this.index) return;
    var prev = this.slides[this.index];
    var incoming = this.slides[next];
    loadSlideImages(incoming);
    loadSlideImages(this.slides[(next + 1) % count]);

    prev.classList.remove('is-active');
    prev.classList.add('is-prev');
    prev.setAttribute('aria-hidden', 'true');
    incoming.classList.add('is-active');
    incoming.removeAttribute('aria-hidden');
    clearTimeout(prev.__luxPrevTimer);
    prev.__luxPrevTimer = setTimeout(function () { prev.classList.remove('is-prev'); }, reduceMotion ? 50 : FADE_MS + 100);

    this.dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === next);
      if (i === next) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
    this.captions.forEach(function (c, i) {
      var active = i === next;
      c.hidden = !active;
      c.classList.toggle('is-active', active);
      var link = c.querySelector('a');
      if (link) link.tabIndex = active ? 0 : -1;
    });

    this.index = next;
    // Fortschrittsbalken neu starten
    this.root.classList.remove('is-running');
    void this.root.offsetWidth;
    this.remaining = this.interval;
    if (user) this.restart();
    else this.schedule();
  };

  Slider.prototype.canRun = function () {
    return this.autoplay && !this.userPaused && !this.hoverPaused && this.inView && !document.hidden;
  };

  Slider.prototype.schedule = function () {
    var self = this;
    clearTimeout(this.timer);
    if (!this.canRun()) {
      this.root.classList.add('is-paused');
      return;
    }
    this.root.classList.remove('is-paused');
    this.root.classList.add('is-running');
    this.startedAt = Date.now();
    this.timer = setTimeout(function () { self.go(self.index + 1, false); }, this.remaining);
  };

  Slider.prototype.pause = function () {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
      this.remaining = Math.max(400, this.remaining - (Date.now() - this.startedAt));
    }
    this.root.classList.add('is-paused');
  };

  Slider.prototype.play = function () {
    if (!this.autoplay) {
      this.root.classList.add('is-paused', 'is-static');
      return;
    }
    this.schedule();
  };

  Slider.prototype.restart = function () {
    this.remaining = this.interval;
    this.schedule();
  };

  Slider.prototype.refresh = function () {
    if (this.canRun()) this.schedule();
    else this.pause();
  };

  Slider.prototype.updateToggle = function () {
    if (!this.toggleBtn) return;
    var paused = !this.autoplay || this.userPaused;
    this.root.classList.toggle('is-user-paused', paused);
    this.toggleBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    this.toggleBtn.setAttribute('aria-label', paused ? 'Automatischen Wechsel starten' : 'Automatischen Wechsel anhalten');
  };

  Slider.prototype.bind = function () {
    var self = this;
    var root = this.root;

    root.addEventListener('click', function (e) {
      var go = e.target.closest('[data-go]');
      if (go) { self.go(+go.getAttribute('data-go'), true); return; }
      if (e.target.closest('[data-next]')) { self.go(self.index + 1, true); return; }
      if (e.target.closest('[data-prev]')) { self.go(self.index - 1, true); return; }
      if (e.target.closest('[data-toggle]')) {
        if (!self.autoplay) { self.autoplay = self.slides.length > 1; self.userPaused = false; root.classList.remove('is-static'); }
        else self.userPaused = !self.userPaused;
        self.updateToggle();
        if (self.userPaused) self.pause();
        else self.restart();
      }
    });

    // Tastatur: Pfeiltasten, solange der Fokus in der Navigation liegt
    var nav = root.querySelector('.lux-hs__nav');
    if (nav) {
      nav.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1, true); }
      });
    }

    // Pause bei Hover über der Navigation (nicht über dem ganzen Hero – sonst liefe er am Desktop nie)
    var bar = root.querySelector('.lux-hs__bar');
    if (bar) {
      bar.addEventListener('mouseenter', function () { self.hoverPaused = true; self.pause(); });
      bar.addEventListener('mouseleave', function () { self.hoverPaused = false; self.refresh(); });
    }
    root.addEventListener('focusin', function () { self.hoverPaused = true; self.pause(); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { self.hoverPaused = false; self.refresh(); }
    });
    document.addEventListener('visibilitychange', function () { self.refresh(); });

    // Swipe (horizontal), vertikales Scrollen bleibt frei
    var startX = null;
    var startY = null;
    var area = root.querySelector('.lux-hs__slides');
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      startX = e.clientX; startY = e.clientY;
    }, { passive: true });
    root.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      startX = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        self.go(self.index + (dx < 0 ? 1 : -1), true);
      }
    }, { passive: true });
    root.addEventListener('pointercancel', function () { startX = null; });
    if (area) area.style.touchAction = 'pan-y';
  };

  Slider.prototype.observe = function () {
    var self = this;
    var sticky = this.root.querySelector('[data-sticky-cta]');
    if (!('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        self.inView = entry.isIntersecting;
        self.refresh();
      });
    }, { threshold: 0.15 }).observe(this.root);

    if (!sticky) return;
    // Mobile CTA-Leiste: sichtbar, wenn Hero aus dem Bild ist – ausgeblendet über Fahrzeug-Check und Abschluss-CTA
    var state = { heroGone: false };
    var blockers = document.querySelectorAll('#fahrzeug-check, .lux-cta, footer.footer');
    var visibleBlockers = new Set();
    function update() {
      var show = state.heroGone && visibleBlockers.size === 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.querySelectorAll('a').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
    }
    new IntersectionObserver(function (entries) {
      state.heroGone = !entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(this.root);
    var blockIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visibleBlockers.add(entry.target);
        else visibleBlockers.delete(entry.target);
      });
      update();
    }, { threshold: 0.2 });
    blockers.forEach(function (el) { blockIo.observe(el); });
  };

  function init() {
    document.querySelectorAll('[data-lux-slider]').forEach(function (root) {
      if (!root.__luxSlider) root.__luxSlider = new Slider(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-lux-slider]');
    if (root && root.__luxSlider) {
      var idx = e.target.getAttribute('data-slide');
      if (idx !== null) { root.__luxSlider.userPaused = true; root.__luxSlider.updateToggle(); root.__luxSlider.go(+idx, true); root.__luxSlider.pause(); }
    }
  });
})();
